import { ODataSelect } from "../../../Providers.Api/ODataQuery";

export class stores extends ODataSelect
{
    public Node_Id = 0;
    public Space_Id = "";
    public Space_Name = "";
    public Space_Type = "";}


export class EquipmentView extends ODataSelect
{
    public Node_Id = 0;
    public Equip_Id = "";
    public Equip_Name = "";
    public Equip_Type = "";
    public Equip_Class = "";
    public ImageURI = "";
    public Booking_Resource_Id = "";
    public Meta_Loc_Zone = "";
    public Store_Space_Id = "";
}
